import { Card, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import { getCurrentSummary } from "../../api/monthly_summaries";
import Calendar from "../../components/Doctor/Calendar";

export default function Dashboard() {
  const { data: summary, refetch } = useQuery({
    queryKey: ["summary"],
    queryFn: () => getCurrentSummary(),
    throwOnError: true,
  });

  const handleUpdateSummary = async () => {
    await refetch();
  };

  return (
    <>
      <Card
        sx={{
          borderRadius: "4px",
        }}
      >
        <Calendar updateSummary={handleUpdateSummary} />
      </Card>
      <Box
        sx={{
          marginTop: "20px",
          width: "100%",
        }}
      >
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} sm={5}>
            <Card
              sx={{
                height: "100%",
                borderRadius: "6px",
                padding: "8px",
              }}
            >
              {/*今月の報酬*/}
              {/*<Typography variant="h5" sx={{*/}
              {/*    padding: '8px',*/}
              {/*    color: 'var(--primary-main, #21456A)',*/}
              {/*}}>*/}
              {/*    { summary && (summary.sum?.reward ?? 0).toLocaleString() }円*/}
              {/*</Typography>*/}
            </Card>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Card
              sx={{
                height: "100%",
                borderRadius: "6px",
                padding: "8px",
              }}
            >
              今月の労働時間
              <Typography
                variant="h5"
                sx={{
                  padding: "8px",
                  color: "var(--primary-main, #21456A)",
                }}
              >
                {summary && Math.floor((summary.sum?.work_duration ?? 0) / 60)}
                時間
              </Typography>
              <Typography
                sx={{
                  paddingLeft: "8px",
                  color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
                  /* list/subheader */
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "48px",
                  letterSpacing: "0.1px",
                }}
              >
                内訳
              </Typography>
              <Typography
                sx={{
                  paddingLeft: "8px",
                  /* typography/body2 */
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "143%" /* 20.02px */,
                  letterSpacing: "0.25px",
                }}
              >
                {summary?.detail?.map((s, i) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                  <Box sx={{ display: "flex" }} key={i}>
                    <Box sx={{ width: "120px" }}>{s.schedule_type__name}</Box>
                    <Box sx={{ width: "80px" }}>{s.frequency}回</Box>
                    <Box sx={{ width: "120px" }}>
                      {Math.floor(s.work_duration / 60)}時間
                    </Box>
                  </Box>
                ))}
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
